import { __awaiter, __generator } from "tslib";
import { deleteItem } from '@office-start/idb-cache';
import { IDLE_VERYLOW_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import { dbStoreName } from '../models/Constants';
import { getCachedEdgeworthDb } from './EdgeworthDb';
export function deleteItemsFromCache(itemIds) {
    return __awaiter(this, void 0, void 0, function () {
        var db;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getCachedEdgeworthDb()];
                case 1:
                    db = _a.sent();
                    return [2 /*return*/, Promise.all(itemIds.map(function (itemId) {
                            return new Promise(function (resolveDelete, rejectDelete) {
                                scheduleWork(function () {
                                    deleteItem(db, dbStoreName, itemId)
                                        .then(resolveDelete)
                                        .catch(rejectDelete);
                                }, IDLE_VERYLOW_PRIORITY);
                            });
                        }))];
            }
        });
    });
}
//# sourceMappingURL=deleteItemsFromCache.js.map